export const formatDeviceModelDisplay = (
  model: string | null,
  revision: string | null,
): string | null => {
  if (!model) {
    return null;
  }

  if (!revision) {
    return model;
  }

  return `${model.toUpperCase()}-${revision}`;
};
